








import { Component, Mixins } from "vue-property-decorator";
import { DocumentEditableMixin } from "../../mixins";
import { default as DocumentEditNavigator } from "./DocumentEditNavigator.vue";
import { default as DocumentPageNavigator } from "./DocumentPageNavigator.vue";

@Component({
  components: {
    DocumentEditNavigator,
    DocumentPageNavigator,
  },
})
export default class Footer extends Mixins(DocumentEditableMixin) {}
